import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { useModal } from '@/components/modal/useModal';
import SiClose from '@/icons/SiClose';
import { cn } from '@/lib/utils';
import DeleteBundleModal from '@/pages/customer/bundles/DeleteBundleModal';
import { Menu } from '@headlessui/react';
import { FC, useRef, useState } from 'react';
import { FiMenu } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

interface Props {
  bundleId: string;
  showDetailCallback: (show: boolean) => void;
}
export const BundleActionsMenu: FC<Props> = ({ bundleId, showDetailCallback }) => {
  const navigate = useNavigate();

  const deleteBundleModalProps = useModal<{ bundleId: string }>();

  const [quickViewExpanded, setQuickViewExpanded] = useState(false);

  const onQuickviewToggle = () => {
    setQuickViewExpanded(!quickViewExpanded);
    showDetailCallback(!quickViewExpanded);
  };

  const ref = useRef<HTMLButtonElement>(null);
  const [showAbove, setShowAbove] = useState<boolean>(false);

  const calculatePosition = () => {
    const windowHeight = window.innerHeight;

    const buttonRect = ref.current?.getBoundingClientRect();
    const buttonTop = buttonRect?.y;

    setShowAbove(buttonTop ? buttonTop > windowHeight * 0.6 : false);
  };

  return (
    <>
      <Menu>
        <Menu.Button
          as="button"
          className="flex items-center justify-center gap-2"
          ref={ref}
          onClick={calculatePosition}
        >
          <div className="relative">
            <div className="flex items-center justify-center rounded-full px-5">
              <FiMenu className="text-2xl" />
            </div>
            <Menu.Items
              className={twMerge(
                'absolute z-50 right-0 mt-2 min-w-fit w-[200px] divide-y',
                'divide-gray-100 rounded-md border border-gray-200 bg-white',
                'shadow-lg outline-none',
                showAbove ? ' bottom-[110%]' : 'top-[100%]'
              )}
            >
              <div>
                <Menu.Item>
                  <Button
                    variant={ButtonVariant.Mono}
                    onClick={onQuickviewToggle}
                    className={cn('rounded-none border-0 w-full')}
                  >
                    {quickViewExpanded ? 'Hide Details' : 'Show Details'}
                  </Button>
                </Menu.Item>
                <Menu.Item>
                  <Button
                    variant={ButtonVariant.Mono}
                    onClick={() => navigate(`${bundleId}`)}
                    className="rounded-none border-0 w-full"
                  >
                    Edit Bundle
                  </Button>
                </Menu.Item>
                <Menu.Item>
                  <Button
                    variant={ButtonVariant.DesctructiveGhost}
                    onClick={() => deleteBundleModalProps.open({ bundleId })}
                    className="rounded-none border-0 w-full"
                  >
                    <SiClose className="text-xl" /> <span>Delete</span>
                  </Button>
                </Menu.Item>
              </div>
            </Menu.Items>
          </div>
        </Menu.Button>
      </Menu>
      <DeleteBundleModal {...deleteBundleModalProps} />
    </>
  );
};
